import { useTranslationInterface } from 'utils/hooks/useTranslation';

export const useExperimentsTranslations = () => useTranslationInterface('experiments');
export const useMetricsTranslations = () => useTranslationInterface('metrics');
